import React, { useEffect, useState, useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Grid,
  FormControl,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { saveNoteAction, updateNoteAction } from '../../redux/actions/noteActions';
import { getPolicySearchPolicyListAction } from '../../redux/actions/policyActions';
import debounce from 'lodash.debounce';
import { getPolicyListingAction } from '../../redux/actions/customerDetailsAction';
import  { getCustomerDataAction } from '../../redux/actions/customerSearchAction';
function AddNotes({
  selected_customer_list,
  editData,
  setShowNote,
  editPolicy,
  getNoteId,
  noteType,
  onNotesUpdated,
  customerId,
  selectedPolicyId,
}) {
  const { control, handleSubmit, formState: { errors }, reset } = useFormContext();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');
  // const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedNoteType, setSelectedNoteType] = useState(noteType || "");
  const [selectPolicyId, setSelectPolicyId] = useState(selectedPolicyId || "");
  const [noteTypeError, setNoteTypeError] = useState(false);
  const [policyIdError, setPolicyIdError] = useState(false);
  const [noteTarget, setNoteTarget] = useState("Customer");
  const list = useSelector((state) => state.customerDetails.policy_listing)
  const policy_customer_list = useSelector((state) => state?.globalSearchReducer?.customer_data?.content || []);
  const final_policy_list = selected_customer_list ? selected_customer_list : policy_customer_list;
  const customer_id = useSelector((state) => state?.customerDetails?.client_customer_id || null);
   
  const [isInitialized, setIsInitialized] = useState(false);

useEffect(() => {
    if (final_policy_list?.length > 0 && !selectPolicyId && noteTarget === "Policy" && !isInitialized) {
        const firstPolicy = final_policy_list[0];
        setSelectPolicyId(firstPolicy.id);
        setIsInitialized(true);

        const syntheticEvent = { target: { value: firstPolicy.id } };
        handlePolicyChange(syntheticEvent);
    }
}, [final_policy_list, noteTarget, selectedPolicyId, dispatch, isInitialized]);


  useEffect(() => {
    if(customer_id){
      dispatch(getPolicyListingAction(customer_id));
      dispatch(getCustomerDataAction(customer_id,0,25));
    }
  }, [customer_id]);

  useEffect(() => {
    if (editData) {
      setSelectedNoteType(editData.type || "");
      if (editData.clientCustomerId) {
        setNoteTarget("Customer");
      } else {
        setNoteTarget("Policy");
        setSelectPolicyId(editData.policyId);
      }

      reset({
        message: editData.message || ""
      });
    }
  }, [editData, reset]);


  const callbackfn = (res) => {
    const policyList = res.content || [];
    const list = policyList?.map((policy) => ({
      id: policy.id,
      policyNumber: policy.policyNumber,
    }));
    setLoading(false);
  };

  const fetchPolicyOptions = useCallback(
    debounce((query) => {
      setLoading(true);
      dispatch(getPolicySearchPolicyListAction(query,0,25, callbackfn));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (inputValue.length >= 3) {
      fetchPolicyOptions(inputValue);
    } else {
      // setOptions([]);
      setLoading(false);
    }
  }, [inputValue, fetchPolicyOptions]);

  const handlePolicyChange = (event) => {
    setSelectPolicyId(event.target.value);
  };

  const handleNoteTargetChange = (event) => {
    setNoteTarget(event.target.value);
    if (event.target.value === "Customer") {
      setPolicyIdError(false);
    }
  };

  const onSubmit = async (data) => {
    let hasError = false;

    if (!selectedNoteType) {
      setNoteTypeError(true);
      hasError = true;
    } else {
      setNoteTypeError(false);
    }

    if (noteTarget === "Policy" && !selectPolicyId) {
      setPolicyIdError(true);
      hasError = true;
    } else {
      setPolicyIdError(false);
    }

    if (hasError) return;

    const formData = {
      ...data,
      notesSource: 'USER',
      type: selectedNoteType,
    };

    if (noteTarget === "Customer") {
      formData.clientCustomerId = editPolicy
        ? editData?.clientCustomerId || customerId || customer_id
        : customerId || customer_id;
      formData.policyId = null;
    } else if (noteTarget === "Policy") {
      formData.policyId = selectPolicyId;
      formData.clientCustomerId = null;
    }

    try {
      if (editPolicy) {
        const payload = {
    ...formData,
    clientCustomerId: editData.clientCustomerId || null,
    policyId: editData.policyId || null,
    id: getNoteId
  };

  // Remove null/undefined properties
  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value != null)
  );

  await dispatch(updateNoteAction(cleanPayload));
      } else {
        await dispatch(saveNoteAction(formData));
      }

      onNotesUpdated();
    } catch (error) {
      console.error("Error saving/updating note:", error);
    }

    reset();
    setShowNote(false);
  };
  return (
    <Dialog open={true} onClose={(event, reason) => { if (reason === "backdropClick" || reason === "escapeKeyDown") { return; } setShowNote(false); }} 
      fullWidth maxWidth="sm" disableScrollLock={true} keepMounted={false} hideBackdrop={false} style={{ zIndex: 1300 }}>
      <DialogTitle
      >
        {editPolicy ? 'Edit Note' : 'Add Note'}
        <IconButton
          aria-label="close"
          onClick={() => setShowNote(false)}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  name="noteTarget"
                  value={noteTarget}
                  onChange={handleNoteTargetChange}
                >
                  <FormControlLabel value="Customer" control={<Radio />} label="Customer" />
                  <FormControlLabel value="Policy" control={<Radio />} label="Policy" />
                </RadioGroup>
              </FormControl>
            </Grid>

            {noteTarget === "Policy" && (
              <Grid item xs={6}>
                <FormControl fullWidth error={!!policyIdError}>
                  <Typography>Select Policy</Typography>
                  <Select
                    value={selectPolicyId || ''}
                    onChange={(e) => {
                      handlePolicyChange(e);
                      setPolicyIdError(false);
                    }}
                    displayEmpty
                  >
                    <MenuItem value="" >Select a policy</MenuItem>
                    {list?.map((policy) => (
                     <MenuItem key={policy.id} value={policy.id}>
                      {policy.policyNumber}
                     </MenuItem>
                    ))}
                  </Select>
                  {policyIdError && (
                    <Typography variant="caption" color="error">
                      Please select a policy number
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            )}

            <Grid item xs={noteTarget === "Policy" ? 6 : 12}>
              <FormControl fullWidth error={!!noteTypeError}>
                <Typography>Note Type<span style={{ color: "red" }}>*</span></Typography>
                <Select
                  value={selectedNoteType}
                  onChange={(e) => {
                    setSelectedNoteType(e.target.value);
                    setNoteTypeError(false);
                  }}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select Note Type</MenuItem>
                  <MenuItem value="Billing">Billing</MenuItem>
                  <MenuItem value="Cancellation">Cancellation</MenuItem>
                  <MenuItem value="Claims">Claims</MenuItem>
                  <MenuItem value="Cross-Sell Follow Up">Cross-Sell Follow Up</MenuItem>
                  <MenuItem value="Customer Concerns/Questions">Customer Concerns/Questions</MenuItem>
                  <MenuItem value="Follow Up">Follow Up</MenuItem>
                  <MenuItem value="Pending Cancellation">Pending Cancellation</MenuItem>
                  <MenuItem value="Policy Changes">Policy Changes</MenuItem>
                  <MenuItem value="Policy Review">Policy Review</MenuItem>
                  <MenuItem value="Quote">Quote</MenuItem>
                  <MenuItem value="Renewal">Renewal</MenuItem>
                  <MenuItem value="Underwriting">Underwriting</MenuItem>
                  <MenuItem value="General ">General</MenuItem>
                </Select>
                {noteTypeError && (
                  <Typography variant="caption" color="error">
                    Note Type is required
                  </Typography>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth error={!!errors.message}>
               <Typography>
                  Notes <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Controller
                  name="message"
                  control={control}
                  rules={{ required: 'Notes cannot be empty' }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      multiline
                      minRows={4}
                      error={!!errors.message}
                      helperText={errors.message?.message}
                    />
                  )}
                />

              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setShowNote(false)}
            variant="outlined"
            size='large'
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            size='large'
          >
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default AddNotes;